<template>
  <section v-if="Object.keys(list).length" class="content--perferror" :style="bgColor ? 'background-color: ' + bgColor : ''">
    <span>{{ title ? title : 'Pas si vite !' }}</span><br /><br />
    <template v-for="msgList in list">
      <span v-for="msg in (Array.isArray(msgList) ? msgList : [msgList])" :key="msg"><!-- app-error-msg not with errorMsgList -->
        - {{ msg }}
        <br />
      </span>
    </template>
    <slot></slot>
    <template v-if="! isHideFooterMsg">
      <br />
      Un problème ? <a :href="'tel:'+$telSupport">Appelez-nous</a>
    </template>
  </section>
</template>

<script>
export default {
  props: ['list', 'title', 'isHideFooterMsg', 'bgColor']
}
</script>
